import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d368324&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleHero: require('/usr/src/app/components/articles/article-hero.vue').default,CategoriesPuzzle: require('/usr/src/app/components/articles/categories-puzzle.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default})
